module.exports = __webpack_public_path__ + "media/images/budova-venku-84dc82f5.png";